import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useUser from "./useUser";

export default function useBaType(allowed = []) {
  const user = useUser();
  const history = useHistory();

  useEffect(() => {
    // Authentication guard should be handled elsewhere
    if (user) {
      if (allowed.includes(user.baType)) {
        return;
      }

      // Redirect when baType is not allowed
      history.replace("/");
    }
  }, [user, history]);
}
